export default {
  wallet: {
    title: 'ウォレット',
    balance: '残高',
    deposit: '入金',
    withdraw: '出金',
    rollover: 'ロールオーバー',
    transaction: '取引履歴',
    myBet: 'マイベット',
    totalBalance: '合計残高',
    withdrawableBalance: '出金可能残高',
    bonus: 'ボーナス',
    bonusBalance: 'ボーナス残高',
    cashBalance: '現金残高',
    withdrawable: '出金可能',
    depositNow: '今すぐ入金',
    getBonus: 'ボーナスを受け取る',
    bonusGames: 'ボーナスゲーム',
    playNow: '今すぐプレイ',
    fiatAccount: '法定通貨アカウント',
    cash: '現金',
    rules: 'ルール',
    ruleQ1: '1. ボーナスとは？',
    ruleA1: 'ボーナスはアクティビティに参加した後にプラットフォームから付与される報酬で、指定されたボーナスゲームでベットに使用できます。',
    ruleQ2: '2. ボーナスはどうやって使いますか？',
    ruleA2: 'ボーナスは現金ウォレットの残高がなくなった後にのみベットに使用できます。ボーナスは賭け条件を満たしてから現金ウォレットに変換できます。',
    ruleQ3: '3. どのゲームがボーナスベットに対応していますか？',
    ruleA3: 'ほとんどのスロットゲームがボーナスベットに対応しています。ゲームの詳細一覧はボーナスゲームページをご覧ください。',
    ruleQ4: '4. ボーナスを現金ウォレットに変換する際に制限はありますか？',
    ruleA4: 'ボーナスベットの賭け条件を満たすと、リワードセンターで元のボーナスを現金ウォレットに変換できます。残ったボーナス利益はボーナスウォレットに戻され、賭け条件が再計算されます。',
    ruleQ5: '5. ボーナス利益を現金ウォレットに変換する際に制限はありますか？',
    ruleA5: 'ボーナス利益は15倍の賭け条件を満たす必要があります。現金ウォレットに変換できるボーナス利益の上限はUSDT5,000.00で、1回のベット上限はUSDT1,000.00です。',
    ruleQ6: '6. 賭け条件はどのように計算されますか？',
    ruleA6: 'スロットゲーム：ベット額 = 賭け条件 その他のゲーム：ベット額 = 利益の絶対値（ベット額まで）',
    select: '選択',
    currency: '通貨',
    loading: '読み込み中...',
    noMoreData: 'これ以上のデータはありません',
    noData: 'データなし',
    colType: '種類',
    colTime: '時間',
    colStatus: 'ステータス',
    colAmount: '金額',
    colBalance: '残高',
    allType: 'すべての種類',
    allStats: 'すべてのステータス',
    colWallet: 'ウォレット',
    colCurrent: '現在',
    colRequired: '必要額',
    colStats: 'ステータス',
    totalVaultBalance: '金庫の合計残高',
    amount: '金額',
    availableBalance: '利用可能残高：',
    max: '最大',
    depositInVault: '金庫に入金',
    depositCurrency: '入金通貨',
    currencyBalance: '通貨別残高',
    history: '履歴',
    vaultRules: '金庫のルール',
    vaultRule1: '金庫は、取引手数料やブロックチェーンの遅延を気にせず資金を保管できる安全な場所です。金庫はあなた専用のデジタルウォレットや銀行の貯蓄口座のように機能します。2FAにより非常に安全で、資金を守るために強化されたセキュリティ対策を導入できます。',
    vaultRule2: '金庫での資金の入金と出金は2FAで保護されており、預金者はいつでもアクセスできます。',
    vaultRule3: '金庫内の資金は預金者以外の誰にも触れられません。それはあなたのものであり、いつでも安全にご利用いただけます！',
    selectTime: '期間を選択',
    colGame: 'ゲーム',
    colBet: 'ベット',
    colWin: '勝利',
    colProfit: '利益',
    sports: 'スポーツ',
    allGames: 'すべてのゲーム',
    today: '今日',
    yesterday: '昨日',
    last3Days: '過去3日間',
    last7Days: '過去7日間',
    last15Days: '過去15日間',
    last30Days: '過去30日間',
  },
};
